var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-items',{attrs:{"items":_vm.stores,"restoreState":false}}),_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"mt-3 color"},[_c('pagination',{attrs:{"meta":_vm.paginationMeta,"on-change-page":_vm.changePage}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }